import { render, staticRenderFns } from "./PressPostOverview.vue?vue&type=template&id=52e4f880&scoped=true&"
import script from "./PressPostOverview.vue?vue&type=script&lang=js&"
export * from "./PressPostOverview.vue?vue&type=script&lang=js&"
import style0 from "./PressPostOverview.vue?vue&type=style&index=0&id=52e4f880&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e4f880",
  null
  
)

export default component.exports